import { render } from "./CommunityPostFeedView.vue?vue&type=template&id=ce25dde4&scoped=true&ts=true"
import script from "./CommunityPostFeedView.vue?vue&type=script&lang=ts"
export * from "./CommunityPostFeedView.vue?vue&type=script&lang=ts"

import "./CommunityPostFeedView.vue?vue&type=style&index=0&id=ce25dde4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce25dde4"]])

export default __exports__